import {
  deluxeProps,
  topMatchProps,
} from '../../Templates/Assessment/Assessment';
import Deluxe from '../Deluxe/Deluxe';
import { Tag } from 'carbon-components-react';
import { TranslationFunction } from 'src/common/hooks/widgets/useTranslation';

type dataProps = {
  data: topMatchProps;
  deluxe: boolean;
  deluxeData: deluxeProps;
  que5Value: string;
  que6Value: string;
  deluxePkg: boolean;
  useTranslation: TranslationFunction;
};

const Result = ({
  data,
  deluxe,
  deluxeData,
  que5Value,
  que6Value,
  deluxePkg,
  useTranslation,
}: dataProps) => {
  const isMTDIncluded = () => {
    return que5Value === 'Yes';
  };

  const isRemoteAccessIncluded = () => {
    return que6Value === 'Remote access';
  };

  return (
    <>
      <p className="result-intro">{useTranslation('results_heading')}</p>
      <div className="page_heading_3 margin-top">
        {deluxePkg ? deluxeData.title : data.title}
      </div>
      <div className="margin-top">
        <span className="topmatch_desc">
          {deluxePkg ? deluxeData.plan : data.plan}
        </span>{' '}
        <span>{data.desc}</span>
      </div>
      <div className="recommended-pt">
        {(isMTDIncluded() || isRemoteAccessIncluded()) && (
          <span className="selection-state">{useTranslation('include')}</span>
        )}
        {isMTDIncluded() && (
          <Tag
            type="purple"
            size="md"
            disabled={false}
            filter={false}
            style={{ marginLeft: '5px' }}
          >
            {useTranslation('mtd')}
          </Tag>
        )}
        {isRemoteAccessIncluded() && (
          <Tag
            type="purple"
            size="md"
            disabled={false}
            filter={false}
            style={{ marginLeft: '5px' }}
          >
            {useTranslation('remote_access')}
          </Tag>
        )}
      </div>
      <div className="mar2">
        <span className="price_table_comp__bodycopy">
          {useTranslation('start_at')}
        </span>
        <span className="page_heading_3">
          {deluxePkg ? deluxeData.price : data.price}*
        </span>
        <div className="tax_text">*{useTranslation('tax_info')}</div>
        {/* remove false when business wants to have delux back */}
        {false && deluxe && (
          <Deluxe
            useTranslation={useTranslation}
            data={deluxeData}
            deluxePkg={deluxePkg}
          />
        )}
      </div>
    </>
  );
};

export default Result;
